import { Avatar } from '@mui/material';
import { useEffect, useMemo } from 'react';

export function MyAvatar({ avatar }: { avatar: string | File | null | undefined }) {
  // Derive avatar source from prop - pure computation without side effects
  const avatarSrc = useMemo(() => {
    if (avatar instanceof File) {
      return URL.createObjectURL(avatar);
    } else if (typeof avatar === 'string') {
      return avatar;
    }
    return undefined;
  }, [avatar]);

  // Cleanup object URL when avatar changes or component unmounts
  useEffect(() => {
    return () => {
      if (avatarSrc && avatarSrc.startsWith('blob:')) {
        URL.revokeObjectURL(avatarSrc);
      }
    };
  }, [avatarSrc]);

  return <Avatar src={avatarSrc} alt="User avatar" sx={{ width: 64, height: 64 }} />;
}
